import HomePage from './HomePage';
import LoginPage from './LoginPage';
import NotFoundPage from './NotFoundPage';

export { HomePage, LoginPage, NotFoundPage };
